module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/school2-a381157a631e9131f11d7d056ab42bb6.svg";